import React, {useState} from "react";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import {Box} from "@mui/system";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from '@mui/icons-material/Save';
import Download from '@mui/icons-material/Download';
import InputAdornment from '@mui/material/InputAdornment';
import {useDispatch, useSelector} from "react-redux";
import axios from 'axios';
import {RedirectURLs, URLs} from "../../utils/urls";
import {ToastContainer} from 'react-toastify';
import {createThumbnailFromJSON, dataURLtoFile, saveEditor} from "../../utils/helpers";
import {showToast} from "../../store/reducers/notificationSlice";
import {fabric} from "fabric";
import {updateSheetObjects} from "../../store/reducers/availableSheets";
import {setIsEditing} from "../../store/reducers/loginSlice";
import {categories} from "../../utils/constants";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const SaveTemplateContent = ({setSaveTemplateModal, isAdminTemp}) => {
    const [loading, setLoading] = useState({json:false, template: false});
    const [tempSaved, setTempSaved] = useState('');
    const [categoriesName, setCategories] = useState('Social Announcements');
    const [templateName, setTemplateName] = useState('');
    const [templatePrice, setTemplatePrice] = useState(0);
    const { isEditing } = useSelector((state) => state.loginSlice);
    const {canvas} = useSelector((state) => state.canvas);
    const activeSheet = useSelector((state) => state.activeSheet).sheet;
    const availableSheets = useSelector((state) => state.availableSheets).sheets;
    const isAdmin = useSelector(state => state.loginSlice).isAdmin;

    const dispatch = useDispatch()

    const saveTemplate = async () => {
        let cover = []
        if (!templateName) {
            alert("Enter the name")
            return
        }
        setLoading({...loading, template: true});
        const formData = new FormData();
        const {canvasData} = await saveEditor(templateName, availableSheets, activeSheet, canvas);

        let sheetSize = {
            size: availableSheets[0].size
        }

        const tmpCanvas = new fabric.StaticCanvas('');

        dispatch(updateSheetObjects({
            sheetId: activeSheet.id,
            objectList: [...canvas.getObjects()],
        }));
        for (let ind = 0; ind < availableSheets.length; ind++) {
            let thumbnail = await createThumbnailFromJSON(availableSheets[ind], tmpCanvas)
            cover.push(thumbnail)
            formData.append(`sheet_${ind}`, dataURLtoFile(thumbnail, 'image.png'));
        }

        if (isAdmin && isAdminTemp) {
            formData.append('categories', categoriesName);
            formData.append('price', templatePrice.toLocaleString());
            formData.append('coverpic', dataURLtoFile(cover[0], 'image.png'));
            formData.append('Title', templateName);
            formData.append('FabricJs', canvasData);
            formData.append('MetaData', JSON.stringify(sheetSize));

            const token = sessionStorage.getItem('auth_token');
            if (isEditing.value) {
                let {ADMIN_PRODUCT} = URLs;
                axios.patch(`${ADMIN_PRODUCT}${isEditing.id}/`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${token}`,
                    }
                })
                    .then(() => {
                        setLoading({...loading, template: false});
                        setSaveTemplateModal(false)
                        dispatch(showToast({message: "Template updated Successfully!", type: "success"}));
                    })
                    .catch((error) => {
                        dispatch(showToast({message: "Template could not updated!", type: "error"}));
                        setLoading({...loading, template: false});
                    });
            } else {
                axios.post(URLs.ADMIN_PRODUCT, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${token}`,
                    }
                })
                    .then(response => {
                        setLoading({...loading, template: false});
                        setSaveTemplateModal(false)
                        const newUrl = `${RedirectURLs.REDIRECT_ECOM}${response.data.id}`;
                        window.parent.postMessage({ newUrl }, '*');
                        dispatch(setIsEditing({ value: true, id: response.data.id, type: 'editTemplate' }));
                        dispatch(showToast({message: "Template saved Successfully!", type: "success"}));
                    })
                    .catch(error => {
                        dispatch(showToast({message: "Template could not saved!", type: "error"}));
                        setLoading({...loading, template: false});
                    });
            }
        }
    }
    const handleChange = (event) => {
        setCategories(event.target.value);
    };
    const templateNameHandler = (event) => {
        setTemplateName(event.target.value)
    };
    const templatePriceHandler = (event) => {
        setTemplatePrice(event.target.value)
    };

    const handleDownload = async () => {
        setLoading({ ...loading, json: true });

        const {canvasData} = await saveEditor(templateName, availableSheets, activeSheet, canvas);

        const jsonBlob = new Blob([canvasData], { type: 'application/json' });

        const a = document.createElement('a');
        a.href = URL.createObjectURL(jsonBlob);
        a.download = 'file.json';
        a.click();
        setLoading({ ...loading, json: false });

    };

    return (
        <>
            <ToastContainer />
            <div className="template-form-wrapper">
                <Stack
                    component="form"
                    sx={{
                        width: '25ch',
                    }}
                    spacing={2}
                    noValidate
                    autoComplete="off"
                >
                    <span>Template Name</span>
                    <TextField
                        hiddenLabel
                        fullWidth
                        id="fullWidth"
                        placeholder="My Template"
                        size="small"
                        value={templateName}
                        onChange={templateNameHandler}
                    />
                    {isAdminTemp &&
                        <>
                            <span>Template Price</span>
                            <FormControl size="small" fullWidth sx={{ m: 1 }}>
                                <OutlinedInput
                                    type={'number'}
                                    value={templatePrice}
                                    onChange={templatePriceHandler}
                                    id="outlined-adornment-amount"
                                    startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                />
                            </FormControl>
                        </>
                    }
                </Stack>
                <FormControl size="small" sx={{ width: 300 }}>
                    <span>Select Categories</span>
                    <Select
                        sx={{ mt: 2 }}
                        id="demo-multiple-checkbox"
                        value={categoriesName}
                        defaultValue={"Social Announcements"}
                        onChange={handleChange}
                        input={<OutlinedInput />}
                        MenuProps={MenuProps}
                    >
                        {categories.map((category) => (
                            <MenuItem key={category} value={category}>
                                {category}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <Box sx={{ gap: 2, mt: 2, mr: 2, display: 'flex', justifyContent:'end'}}>
                <LoadingButton
                    onClick={handleDownload}
                    loading={loading.json}
                    loadingPosition="end"
                    endIcon={<Download />}
                    variant="contained"
                >
                    <span>Download JSON</span>
                </LoadingButton>
                <LoadingButton
                    onClick={saveTemplate}
                    loading={loading.template}
                    loadingPosition="end"
                    endIcon={<SaveIcon />}
                    variant="contained"
                >
                    <span>Save Template</span>
                </LoadingButton>
            </Box>
            {tempSaved &&
                <Box sx={{ mt: 1, mr: 2, display: 'flex', justifyContent:'end'}}>
                    <span style={{color:'green'}}>{tempSaved} Saved Successfully [✓]</span>
                </Box>
            }
        </>
    )
}
export default SaveTemplateContent